// extracted by mini-css-extract-plugin
export default {"embed_video":"video_embed_video__R07+l","embed_video_wrapper":"video_embed_video_wrapper__dCTsN","video":"video_video__SFXuS"};